import type { TFunction } from "i18next";

import { PERSONA_LIMIT } from "@/constants/persona";
import { USER_ROLES } from "@/constants/user";

// eslint-disable-next-line id-length -- keep "t" as the standard i18n translation helper for readability and tooling support
const getSubscriptionComparisonFeatures = (t: TFunction) => [
  {
    feature: t("subscription:page.features.unlimitedMessages"),
    [USER_ROLES.FREE]: true,
    [USER_ROLES.MINIMAL]: true,
    [USER_ROLES.BASIC]: true,
    [USER_ROLES.PREMIUM]: true,
  },
  {
    feature: t("subscription:page.features.unlimitedCharacterCreation"),
    [USER_ROLES.FREE]: true,
    [USER_ROLES.MINIMAL]: true,
    [USER_ROLES.BASIC]: true,
    [USER_ROLES.PREMIUM]: true,
  },
  {
    feature: t("subscription:page.features.userPersonas"),
    [USER_ROLES.FREE]: PERSONA_LIMIT.FREE,
    [USER_ROLES.MINIMAL]: PERSONA_LIMIT.PAID_MINIMAL,
    [USER_ROLES.BASIC]: PERSONA_LIMIT.PAID_BASIC,
    [USER_ROLES.PREMIUM]: PERSONA_LIMIT.PAID_PREMIUM,
  },
  {
    feature: t("subscription:page.features.4kContextMemory"),
    [USER_ROLES.FREE]: true,
    [USER_ROLES.MINIMAL]: true,
    [USER_ROLES.BASIC]: true,
    [USER_ROLES.PREMIUM]: true,
  },
];

export default getSubscriptionComparisonFeatures;
